"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var reducers_1 = __importDefault(require("Utils/redux/reducers"));
var store = redux_1.createStore(reducers_1.default);
exports.default = store;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvcmVkdXgvY29uZmlnL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsK0JBQW9DO0FBQ3BDLGtFQUEyQztBQUUzQyxJQUFNLEtBQUssR0FBRyxtQkFBVyxDQUFDLGtCQUFPLENBQUMsQ0FBQztBQU1uQyxrQkFBZSxLQUFLLENBQUMifQ==